import { Component } from 'preact';
import PropTypes from 'prop-types';

export class ErrorModal extends Component {
  render() {
    const { onClose } = this.props;

    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <button
            type="button"
            className="modal-close-button"
            onClick={onClose}
            aria-label="Fechar modal"
          >
            <i className="icon icon-close" />
          </button>

          <h2 className="modal-title">Erro!</h2>
          <p className="modal-message">
            Houve um erro ao tentar realizar o agendamento.
            <br />
            <br />
            Por favor tente novamente.
          </p>
          <button className="modal-button" type="button" onClick={onClose}>
            Entendi
          </button>
        </div>
      </div>
    );
  }
}

ErrorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
